import { Box, Icon, Stack, VStack } from "@chakra-ui/react";
import { FiBarChart2 } from "react-icons/fi";
import type { DisplayMarketingCampaign } from "@common/interfaces/KYDMarketing";
import StatCard from "../../Components/StatCard";
import Headline from "./components/Headline";
import { KYDAdminCampaign } from "@common/interfaces/KYDEvent";
import { getMetric } from "./adSetCardUtils";

const metricsConfig: Array<{
  key: keyof KYDAdminCampaign;
  label: string;
  highlight: boolean;
  isKYD?: boolean;
}> = [
  { key: "display_cpm", label: "Cost per 1K impressions", highlight: false },
  { key: "display_cpc", label: "Cost per click", highlight: false },
  { key: "display_spend", label: "Spend", highlight: false },
  { key: "display_kyd_roas", label: "ROAS", highlight: true, isKYD: true },
  {
    key: "display_ticket_count",
    label: "Checkouts",
    highlight: true,
    isKYD: true,
  },
  { key: "display_ticket_gmv", label: "Sales", highlight: true, isKYD: true },
];

export default function CampaignResultsCard({
  campaign,
}: {
  campaign: DisplayMarketingCampaign;
}) {
  const metrics = campaign.metrics as KYDAdminCampaign;

  return (
    <VStack w="full" alignItems="flex-start" spacing={4} p={0}>
      <Headline
        title="Campaign Results"
        icon={<Icon as={FiBarChart2} color="#A7A7A7" />}
      />
      <VStack spacing={4} w="100%" alignItems="flex-start" p={0}>
        <Stack
          w="100%"
          spacing={4}
          direction={{ base: "column", sm: "row" }}
          flexWrap="wrap"
        >
          {metricsConfig.map(({ key, label, highlight, isKYD }) => (
            <Box
              key={key}
              flex={{ base: "1 1 100%", sm: "1 1 40%", md: "1 1 30%" }}
              minW={{ base: "100%", sm: "140px" }}
            >
              <StatCard
                title={label}
                value={getMetric(metrics, key)}
                isKYD={isKYD}
                highlight={highlight}
                minH={{ base: "68px", md: "80px" }}
              />
            </Box>
          ))}
        </Stack>
      </VStack>
    </VStack>
  );
}
